export default __webpack_public_path__ + "static/media/151-purses.336568c1.png";